import React, { useEffect, useState, } from 'react';
import { useContext } from 'react';

import { useParams } from 'react-router-dom';

import SharedFileList from '../components/SharedFileList';

import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';

import { AuthContext } from '../../shared/context/auth-context';

const UserSharedFiles = () => {
    const auth = useContext(AuthContext);
    const [loadedFiles, setLoadedFiles] = useState();
    const { isLoading, error, sendRequest, clearError } = useHttpClient();

    const userId = useParams().userId;

    useEffect(() => {
        const fetchFiles = async () => {
            try {
                const responseData = await sendRequest(
                    process.env.REACT_APP_BACKEND_URL + `/files/user/${userId}/shared`,
                    'GET',
                    null,
                    {
                        Authorization: 'Bearer ' + auth.token
                    }
                       
                );
                //setLoadedFiles(responseData.files);
                setLoadedFiles(responseData.sharedFiles);
                
            }   catch (err) { }
        };
        fetchFiles();
    },    [sendRequest, userId, auth.token]);


    const deleteFileHandler = fileId => {
        setLoadedFiles(prevFiles =>
            prevFiles.filter(file => file._id !== fileId)
        );
    };

    if (isLoading) {
        return <LoadingSpinner asOverlay />;
    }

    return (
        <React.Fragment>
            <ErrorModal error={error} onClear={clearError} />
            {/*
            {isLoading && (
                <div className="center">
                    <LoadingSpinner />
                </div>
            )}
            */}
            {!isLoading && loadedFiles && <SharedFileList items={loadedFiles} onDeleteFile={deleteFileHandler} />}
        </React.Fragment>
    );

};

export default UserSharedFiles;
